import moment from 'moment';

export const getCalendarValidationValues = (date: Date | null, minDateValue: Date | string) => {
  const minDate = moment(new Date(minDateValue));
  const isPastDate = !!date && date.getTime() < minDate.toDate().getTime();
  const isFutureDate = !!date && date.getTime() > Date.now();
  return { minDate, isPastDate, isFutureDate };
};
